/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';

import type { ConfiguratorService } from 'core/services';

export const ConfiguratorContext = React.createContext<ConfiguratorService>(null);
